import { render, staticRenderFns } from "./PrivateApp.vue?vue&type=template&id=6a0f6419&scoped=true&lang=pug&"
import script from "./PrivateApp.vue?vue&type=script&lang=js&"
export * from "./PrivateApp.vue?vue&type=script&lang=js&"
import style0 from "./PrivateApp.vue?vue&type=style&index=0&id=6a0f6419&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a0f6419",
  null
  
)

export default component.exports